module.exports = __webpack_public_path__ + "f7b428b8fa651c2cf74c7ed869e40fc7.MP3";